// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";

import { PURPOSE_KIND, FEDERAL_STATE, PURPOSE_KIND_DESCRIPTION } from "./formFields";

import { mapPurposeKind, getKind } from "./mappers";
import { type InvestmentProps } from "../../types/details";

const InvestmentFinancingTable = ({ initialValues, handleSubmit, isLocked }: InvestmentProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
        <div />
        <div />
      </FormRow>
      {initialValues[PURPOSE_KIND].map(({ kind }, index) => (
        <FormRow separator key={kind}>
          <EditableField
            fieldControlProps={{
              name: PURPOSE_KIND,
              caption: () => `Investitionsvorhaben ${index + 1}`
            }}
            displayValue={value => {
              const purposeKind = getKind(value, kind);
              return purposeKind && mapPurposeKind(purposeKind.kind);
            }}
          />
          <EditableField
            fieldControlProps={{
              name: PURPOSE_KIND,
              caption: () => "Investitionskosten"
            }}
            displayValue={value => {
              const purposeKind = getKind(value, kind);
              return purposeKind && formatters.formatCurrency(purposeKind.value);
            }}
          />
        </FormRow>
      ))}
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND_DESCRIPTION,
            caption: () => "Vorhaben",
            validate: v.combineWithPrefillCheck(
              errors.requiredField(),
              v.maxLength(500, errors.maxLengthCharacters(500))
            )
          }}
          type="textArea"
          inputProps={{ placeholder: "..." }}
        />
        <div />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentFinancingTable;
